import { createAction, props } from '@ngrx/store';

import { ContactCreateUpdate } from '@lockton-apps/shared/interfaces';

import { ContactCreateUpdateActionTypes } from './types';

export const init = createAction(ContactCreateUpdateActionTypes.Init);

export const contactAdded = createAction(
  ContactCreateUpdateActionTypes.ContactAdded,
  props<{ contact: ContactCreateUpdate }>()
);

export const contactUpdated = createAction(
  ContactCreateUpdateActionTypes.ContactUpdated,
  props<{ contact: ContactCreateUpdate }>()
);

export const destroyed = createAction(ContactCreateUpdateActionTypes.Destroyed);
